"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _classnames = _interopRequireDefault(require("classnames"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _action_file = require("../actions/action_file");
const styles = () => ({
  root: {
    flexGrow: 1
  },
  baseDD: {
    borderRadius: 5,
    height: 30,
    lineHeight: '30px',
    margin: '0 0 10px 0',
    textAlign: 'center',
    verticalAlign: 'middle',
    width: '90%'
  },
  enableDD: {
    border: '2px dashed #000',
    color: '#000'
  },
  disableDD: {
    border: '2px dashed #aaa',
    color: '#aaa'
  },
  tpCard: {},
  tpMoreTxt: {
    padding: '0 0 0 60px'
  },
  tpLabel: {
    fontSize: 16
  }
});
const tpHint = classes => /*#__PURE__*/_react.default.createElement("span", {
  className: (0, _classnames.default)(classes.tpCard)
}, /*#__PURE__*/_react.default.createElement("p", {
  className: (0, _classnames.default)(classes.tpLabel, 'txt-sv-tp')
}, "- Accept *.dx, *.jdx, *.JCAMP,"), /*#__PURE__*/_react.default.createElement("p", {
  className: (0, _classnames.default)(classes.tpLabel, classes.tpMoreTxt, 'txt-sv-tp')
}, "*.RAW, *.mz(X)ML, *.cdf,"), /*#__PURE__*/_react.default.createElement("p", {
  className: (0, _classnames.default)(classes.tpLabel, classes.tpMoreTxt, 'txt-sv-tp')
}, "*.zip (Bruker FID folder)"), /*#__PURE__*/_react.default.createElement("p", {
  className: (0, _classnames.default)(classes.tpLabel, 'txt-sv-tp')
}, "- Max 30Mb"));
const msgDefault = 'Add Spectrum';
const content = (classes, desc) => /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
  title: tpHint(classes),
  placement: "bottom"
}, /*#__PURE__*/_react.default.createElement("span", null, desc));
const InputFile = _ref => {
  let {
    classes,
    editorOnly,
    srcMolSt,
    srcFileSt,
    addFileInitAct
  } = _ref;
  const fileName = srcFileSt && srcFileSt.name;
  const onDrop = files => addFileInitAct({
    file: files[0]
  });
  const enabled = editorOnly || srcMolSt;
  const addOnCls = enabled ? classes.enableDD : classes.disableDD;
  const desc = fileName || msgDefault;
  return (
    /*#__PURE__*/
    // <Dropzone
    //   className="dropbox"
    //   onDrop={onDrop}
    //   disabled={!enabled}
    // >
    _react.default.createElement(_reactDropzone.default, {
      className: "dropbox",
      onDrop: onDrop,
      disabled: false
    }, _ref2 => {
      let {
        getRootProps,
        getInputProps
      } = _ref2;
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, getRootProps(), {
        className: (0, _classnames.default)(classes.baseDD, addOnCls)
      }), /*#__PURE__*/_react.default.createElement("input", getInputProps()), content(classes, desc));
    })
  );
};
const mapStateToProps = (state, props) => (
// eslint-disable-line
{
  srcMolSt: state.mol.src,
  srcFileSt: state.file.src
});
const mapDispatchToProps = dispatch => (0, _redux.bindActionCreators)({
  addFileInitAct: _action_file.addFileInit
}, dispatch);
InputFile.propTypes = {
  classes: _propTypes.default.object.isRequired,
  editorOnly: _propTypes.default.bool.isRequired,
  srcMolSt: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.bool]).isRequired,
  srcFileSt: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.bool]).isRequired,
  addFileInitAct: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _withStyles.default)(styles)(InputFile));